import React from "react";
import { Routes, Route } from "react-router-dom";
// import Home from "../pages/Home";
import ImageCreatorPage from "pages/imageCreator";
import VerifySocalAuthPage from "pages/verifySocialAuth";
// import Profile from "../pages/Profile";
import { routerPath } from "./routerPath";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path={routerPath.HOME} element={<ImageCreatorPage />} />
      <Route
        path={`/${routerPath.IMAGE_CREATOR}`}
        element={<ImageCreatorPage />}
      />
      <Route
        path={`/${routerPath.VERIFY_SOCIAL_AUTH}`}
        element={<VerifySocalAuthPage />}
      />
    </Routes>
  );
};

export default AppRoutes;
